import React from 'react';
import { FormGroup } from 'react-bootstrap';
import {
  FormControl,
  Button,
} from '../form/FormControls.jsx';
import {CenterBox, LinkLikeButton, navTo} from '../../util/util.jsx';
import { connect } from 'react-redux';
import './auth.css';
import { Header } from '@/component/header/Header.jsx';
import { resetPassword } from "../../store/passwordReset.store";

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (token) => resetPassword(dispatch, token)
});

class PasswordResetClass extends React.Component {
  constructor(args) {
    super(args);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      email: ''
    };
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.resetPassword(this.state.email);
  }

  render() {
    return (
      <div>
        <Header loginScreen />
        <CenterBox
          width="500px" height="300px"
          style={{ paddingTop: '56px', background: '#f0f0f0' }}
        >
          <form
            onSubmit={this.onSubmit}
            style={{ padding: '20px 80px', background: 'white', border: 'thin solid lightgray' }}
          >
            <FormGroup>
              <center>
                <h4>
                  Type your email to send reset password link
                </h4>
              </center>
            </FormGroup>
            <FormGroup>
              <FormControl
                type="email" name="email" placeholder="Enter your email here"
                value={this.state.email} onChange={this.handleEmailChange}
              />
            </FormGroup>
            <FormGroup>
              <Button
                id="signin"
                type="submit"
                bsStyle="primary"
                style={{ width: '100%' }}
              >
                Reset password
              </Button>
            </FormGroup>
            <LinkLikeButton onClick={() => navTo(`/auth`)}>
              Return to login page
            </LinkLikeButton>
          </form>
        </CenterBox>
      </div>);
  }
}
PasswordResetClass.propTypes = {
  resetPassword: React.PropTypes.func
};

export const PasswordReset = connect(mapStateToProps, mapDispatchToProps)(PasswordResetClass);
